import { BidcompGridColumnName } from '../../../grid/types/column.types';
import { bidSubmittedValueGetter } from '../../../grid/utils/value-getters/bid-submitted';
import {
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { convertToStringArray } from '../filter-utils';
import { InclusiveExclusiveFilterHandler } from './base/inclusive-exclusive-filter-handler';

export class BidSubmittedFilterHandler extends InclusiveExclusiveFilterHandler {
  protected getValue(params: FilterPassParams): string[] {
    return [bidSubmittedValueGetter({ data: params.deal })];
  }

  get name(): string {
    return BidcompGridColumnName.BidSubmitted;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.bidSubmitted = params.filterOptions.bidSubmitted;
  }

  getFilterOptions(filterOptions: FilterOptions): string[] {
    return convertToStringArray(filterOptions.bidSubmitted);
  }
}
